const poundFormatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
});

export const formatToPound = (nonGBPValue: number) => poundFormatter.format(nonGBPValue);
